import Route from '@ember/routing/route';

export default class SignupErroredRoute extends Route {
  // TODO: add a check that we are in fact in ApplicationFlow.Status.ERRORED
}
